var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.515,20.486A12,12,0,0,1,20.486,3.515,12,12,0,0,1,3.515,20.486ZM2,12A10,10,0,1,0,12,2,10.011,10.011,0,0,0,2,12Zm9,4V8h2v8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrency);
export default __webpack_public_path__ + "static/media/icon-currency.f649cf3192f7ea778eb0c52882342076.svg";
export { ForwardRef as ReactComponent };